module.exports = __webpack_public_path__ + "static/ARB_VISUAL-ATTITUDE-c677c53c8b926d61435f7562395a26d7.jpg";